import { supabase } from "@/lib/supabase";

export const FEEDBACK_CATEGORIES = [
  "bug",
  "feature",
  "wrong_venue_info",
  "wrong_event_info",
  "other",
] as const;

export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number];

export type FeedbackContext = {
  path?: string;
  event_id?: string;
  venue_id?: string;
  user_agent?: string;
};

export const FEEDBACK_CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  bug: "🐛 Bug melden",
  feature: "💡 Feature-Wunsch",
  wrong_venue_info: "📍 Falsche Venue-Info",
  wrong_event_info: "🎉 Falsche Event-Info",
  other: "💬 Sonstiges",
};

export async function submitUserFeedback(
  userId: string,
  category: FeedbackCategory,
  message: string,
  context: FeedbackContext = {},
): Promise<void> {
  const trimmed = message.trim();
  if (!trimmed) throw new Error("Bitte gib eine Nachricht ein.");

  const payload = {
    user_id: userId,
    category,
    message: trimmed,
    context: {
      ...context,
      path: context.path ?? (typeof window !== "undefined" ? window.location.pathname : undefined),
      user_agent:
        context.user_agent ??
        (typeof navigator !== "undefined" ? navigator.userAgent : undefined),
    },
  };

  const { error } = await supabase.from("user_feedback").insert(payload);
  if (error) throw error;
}
